export default "__VITE_ASSET__CEijzKfC__"